module.exports = __webpack_public_path__ + "static/media/night-cloud-snow-icon.5275912d.svg";